function initCategoryListToggle() {
  const categoryListToggles = document.querySelectorAll('#subscriptions .toggle_arrow');

  categoryListToggles?.forEach(function (listToggle) {
    listToggle.addEventListener('click', function (e) {
      const list = this.closest('.form__card').querySelector('.categories_list');
      const inputs = list.querySelectorAll('input');

      if (list.classList.contains('d-none')) {
        this.classList.add('show');
        list.classList.remove('d-none');
      } else {
        this.classList.remove('show');
        list.classList.add('d-none');
      }
    });
  });
}

function initAllCategoriesCheckboxes() {
  const allCategoryListCheckboxes = document.querySelectorAll('[name="all_categories"]');

  allCategoryListCheckboxes?.forEach(function (checkbox) {
    checkbox.addEventListener('click', function (e) {
      const listParent = this.closest('.list_parent');
      const list = listParent.querySelector('.categories_list');
      const categoriesCheckboxes = list.querySelectorAll('input');
      const toggleArrow = listParent.querySelector('#subscriptions .toggle_arrow');
      let allListChecked = false;

      if (this.checked && this.classList.contains('show-block-when-checked')) {
        toggleArrow.classList.add('show');
        list.classList.remove('d-none');
      }

      if (this.checked) {
        allListChecked = true;
      } else {
        list.classList.add('d-none');
        toggleArrow.classList.remove('show');
        allListChecked = false;
      }

      categoriesCheckboxes?.forEach(function (checkbox) {
        checkbox.checked = allListChecked;
      });
    });
  });
}

function initMainCheckbox() {
  const mainCheckbox = document.querySelector('[name="notify_new_contests"]');

  mainCheckbox?.addEventListener('click', function () {
    const listParents = document.querySelector('#main').querySelectorAll('.list_parent');

    listParents?.forEach(function (listParent) {
      const allCategoriesCheckbox = listParent.querySelector('[name="all_categories"]');
      const list = listParent.querySelector('.categories_list');
      const categoryListToggle = listParent.querySelector('#subscriptions .toggle_arrow');
      const categoriesCheckboxes = list.querySelectorAll('input');
      let allListChecked = false;

      if (mainCheckbox.checked && mainCheckbox.classList.contains('show-block-when-checked')) {
        categoryListToggle.classList.add('show');
        list.classList.remove('d-none');
      }

      if (mainCheckbox.checked) {
        allListChecked = true;
      } else {
        categoryListToggle.classList.remove('show');
        list.classList.add('d-none');
        allListChecked = false;
      }

      allCategoriesCheckbox.checked = allListChecked;

      categoriesCheckboxes?.forEach(function (checkbox) {
        checkbox.checked = allListChecked;
      });
    });
  });
}

function uncheckAllCategoriesCheckbox(event) {
  const currentCheckbox = event.currentTarget;

  if (!currentCheckbox.checked) {
    const allCategoriesCheckbox = document.querySelector('[name="notify_new_contests"]');

    if (!allCategoriesCheckbox) {
      return;
    }

    allCategoriesCheckbox.checked = false;

    if (currentCheckbox.name === 'categories[]') {
      const categoriesGroupCheckbox = currentCheckbox.closest('.list_parent').querySelector('[name="all_categories"]');
      categoriesGroupCheckbox.checked = false;
    }
  }
}

// Если сняли чекбокс хотя бы с одной категории, то
// снимаем самый главный чекбокс и
// чекбокс раздела
function initUnchecking() {
  const categoriesGroupCheckboxes = document.querySelectorAll('[name="all_categories"]');

  categoriesGroupCheckboxes?.forEach(function (groupCheckbox) {
    groupCheckbox.addEventListener('click', uncheckAllCategoriesCheckbox);
  });

  const categoriesCheckboxes = document.querySelectorAll('[name="categories[]"]');

  categoriesCheckboxes?.forEach(function (categoryCheckbox) {
    categoryCheckbox.addEventListener('click', uncheckAllCategoriesCheckbox);
  });
}

// При клике на чекбоксе категории или чекбоксе группы категорий
// проверяем, что отмечены все чекбоксы группы и выставляем чекбоксы группы.
// И проверяем если отмечены все чекбоксы, то отмечаем чекбокс всех категорий и групп
function initCheckCategory() {
  const categoriesCheckboxes = document.querySelector('#main')?.querySelectorAll('[name="categories[]"]');

  if (!categoriesCheckboxes) {
    return;
  }

  categoriesCheckboxes?.forEach(function (categoryCheckbox) {
    categoryCheckbox.addEventListener('click', function () {
      initCheckedGroupAndMainCheckboxes();
    });
  });

  const categoriesGroupCheckboxes = document.querySelector('#main')?.querySelectorAll('[name="all_categories"]');

  if (!categoriesGroupCheckboxes) {
    return;
  }

  categoriesGroupCheckboxes?.forEach(function (categoryCheckbox) {
    categoryCheckbox.addEventListener('click', function () {
      initCheckedGroupAndMainCheckboxes();
    });
  });
}

// После загрузки страницы отмечаем чекбоксы групп категорий, если
// вложенные категории отмечены. Также отмечаем главный чекбокс, который
// отмечает все группы категорий
function initCheckedGroupAndMainCheckboxes() {
  const allCategoriesCheckbox = document.querySelector('[name="notify_new_contests"]');
  const categoriesGroupCheckboxes = document.querySelectorAll('[name="all_categories"]');
  let allGroupCheckboxesChecked = true;

  categoriesGroupCheckboxes?.forEach(function (groupCheckbox) {
    let allCategoriesChecked = true;

    const categoriesCheckboxes = groupCheckbox.closest('.list_parent').querySelectorAll('[name="categories[]"]');

    categoriesCheckboxes.forEach(function (categoryCheckbox) {
      if (!categoryCheckbox.checked) {
        allCategoriesChecked = false;
      }
    });

    if (allCategoriesChecked) {
      groupCheckbox.checked = true;
    } else {
      allGroupCheckboxesChecked = false;
    }
  });

  if (categoriesGroupCheckboxes.length && allGroupCheckboxesChecked) {
    allCategoriesCheckbox.checked = true;
  }
}

export default function() {
  // Нажатие на стрелки вниз вверх
  initCategoryListToggle();
  // Включение/отключение чекбоксов групп категорий
  initAllCategoriesCheckboxes();
  // Включение/отключение главного чекбокса всех категорий
  initMainCheckbox();
  // Отключение чекбоксов категорий
  initUnchecking();
  // Включение чекбоксов групп категорий и основного чекбокса
  initCheckedGroupAndMainCheckboxes();
  // Включение чекбоксов категорий
  initCheckCategory();
}